import React from 'react';
import classes from "./AboutSection.module.css";
import { Col, Container, Row } from 'react-bootstrap';
import Image from '../../assets/images/about-us.png';
import SectionHeader from "../../components/SectionHeader";
import Button from "../../components/Button";

export default function AboutSection() {

  const handleScroll = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
        <Container >
            <Row  className='gy-3'>
                <Col lg={6} >
                <img src={Image} alt="img" className={classes.image} />
                </Col>
                <Col lg={6} className={classes.contentDiv}>
                  <SectionHeader title={"About Us"} heading={"Insight-Driven Solutions for Modern Businesses"}/>
                  <p className="f-16">{`Alonzo J. Primus, CPA, MBA is a leader in the financial services,  compliance subprime credit and account servicing industries. He has  founded several businesses in the financial compliance space. He formerly  served as CEO of publicly traded First Bank of Delaware where he managed  direct bank lending, investor management, third party programs and  correspondent lending with national online and storefront and credit card  lenders.  Alonzo has worked with several large consumer finance companies,  hedge funds and servicers over his time in the financial services industry.`}</p>

                  <Row className="mt-5 gap-2">
                    <Col md={4} sm={5}>
                      <Button label={"learn more"} variant={"gradient"} className={classes.btnClass} />
                    </Col>
                    <Col md={4} sm={5}>
                      <Button label={"contact us"} variant={"outlined"} onClick={()=>handleScroll("contact")}/>
                    </Col>
                  </Row>
                </Col>
            </Row>
        </Container>

  )
}
